/**************************************************
 * Nombre:       Home_Catalogo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {LINKMENU, NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import {PictureAsPdf} from '@mui/icons-material'
import CatalogoLista from "./SucComponentes/CatalogoLista";
import {irUrl} from "../../../Utilidades/irUrl";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Catalogo = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography
                                sx={{
                                    fontFamily: NEGRITA,
                                    color: theme.palette.primary.main,
                                    fontSize: sCell ? 32 : 38,
                                    lineHeight: 1.1

                                }}>Catálogo</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: sCell ? 2 : 0}}>
                            <Typography sx={{
                                fontSize: 18,
                                fontWeight: 500,
                                lineHeight: 1.2,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                Desde un desayuno energético hasta una cena llena de sabor, en Quesuditas encuentras el
                                plato perfecto:
                            </Typography>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-end', mt: sCell ? 2 : 0}}>
                    <Button
                        onClick={() => irUrl(LINKMENU)}
                        variant={'outlined'} sx={{letterSpacing: 1,}} endIcon={<PictureAsPdf/>}>Descargar
                        Catalogo</Button>
                </Grid>


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <CatalogoLista/>
            </Grid>

        </Grid>
    )

}
export default Home_Catalogo